const styles = () => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflow: 'hidden',
    minHeight: 500,
  },
  titleWrapper: {
    width: '100%',
    padding: 20,
    textAlign: 'center',
    borderBottom: '1px solid #929292',
  },
  title: {
    fontSize: '20px',
    lineHeight: '23px',
  },
  main: {
    width: '100%',
  },
  textTitle: {
    fontWeight: 'bold',
    opacity: 0.7,
  },
  insidePart: {
    width: '100%',
    padding: '3% 10%',
    position: 'relative',
    borderBottom: '1px solid #979797',
  },
  insidePartMobile: {
    width: '100%',
    padding: '1% 2%',
    position: 'relative',
    borderBottom: '1px solid #979797',
  },
  outsidePart: {
    width: '100%',
    padding: '3% 10%',
    position: 'relative',
  },
  outsidePartMobile: {
    width: '100%',
    padding: '1% 2%',
    position: 'relative',
  },
  text: {
    paddingLeft: 15,
    margin: '10px 0 0 0',
  },
})

export default styles
